import React, { useEffect } from "react"

import { useLocalization } from "@izettle/tenko-react"

import {
  Container,
  Content,
  Flex,
  Title2,
  Anchor,
  WallSuccess,
  RegularText,
  SlideWrapper,
} from "@/core/components/shared"
import { useSlider } from "@/core/components/slider"
import { SlideIndexs } from "@/modules/sign-up/components/types"
import {
  TrackingAction,
  useSignUpTracking,
} from "@/modules/sign-up/hooks/tracking-sign-up"

// eslint-disable-next-line @typescript-eslint/ban-types
export type ContactSentProps = {
  purchaseUuid: string
}

export type ContactSentParams = {
  email?: string
  phone?: string
}

export const ContactSent = ({ purchaseUuid }: ContactSentProps) => {
  const { text } = useLocalization()
  const { goTo, params, index } = useSlider()
  const { email, phone }: ContactSentParams = params
  const { track } = useSignUpTracking(purchaseUuid)

  useEffect(() => {
    if (index === SlideIndexs.ContactSent) {
      track(TrackingAction.ViewedReceiptSent)
    }
  }, [index])

  const handleNoReceiptClicked = () => {
    goTo(SlideIndexs.RetrySendReceipt, { email, phone })
    track(TrackingAction.ClickedResendReceipt, {
      receiptSentTo: email ? "EmailAddress" : "PhoneNumber",
    })
  }

  return (
    <SlideWrapper className={SlideIndexs.ContactSent !== index ? "hidden" : ""}>
      <Container>
        <Content withNoHeaderSpace>
          <WallSuccess style={{ flex: 1 }}>
            <img
              src="https://cdn.izettle.com/customers/success-stamp.svg"
              alt="success"
              height="128px"
              aria-hidden
            />
            <Title2>{text("SIGNUP_RECEIPT_SENT")}</Title2>
            <RegularText>{email ?? phone}</RegularText>
            <Flex>
              <Anchor href="#" onClick={handleNoReceiptClicked}>
                {text("SIGNUP_NO_RECEIPT_QUESTION")}
              </Anchor>
            </Flex>
          </WallSuccess>
        </Content>
      </Container>
    </SlideWrapper>
  )
}
